import React, { useEffect } from 'react'
import {
  Box,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  MenuItem,
  Paper,
  TextField,
} from '@material-ui/core'
import { Lock } from '@material-ui/icons'
import { makeStyles } from '@material-ui/core/styles'
import { Form, Formik } from 'formik'
import { object, array, string } from 'yup'

import LinkButton from '../../common/LinkButton'
import ButtonSubmit from '../../common/ButtonSubmit'
import { privacyPolicyRoute } from '../../../routes/routes'
import { publishViewedInviteMemberByEmail } from '../../../util/events/teamsEventPublishers'
import ButtonDialogClose from '../common/ButtonDialogClose'
import InputMemberEmails from './InputMemberEmails'

const validationSchema = object().shape({
  memberEmails: array()
    .required('Please enter at least one email address.')
    .of(string().email("At least one of the emails you've entered is invalid.")),
})

const useStyles = makeStyles(theme => ({
  paper: {
    paddingBottom: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  infoAlert: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: theme.spacing(3),
    backgroundColor: theme.palette.grey[300],
    fontSize: theme.typography.caption.fontSize,
    color: theme.palette.common.black,
  },
  lockIcon: {
    color: theme.palette.common.black,
    marginRight: theme.spacing(2),
  },
}))

// TODO Should we limit the number of members that can be added via email at once?
// We probably should, but check with the team.
const InviteByEmail = ({ onSubmit, onClose, submitting }) => {
  const classes = useStyles()

  useEffect(() => {
    publishViewedInviteMemberByEmail()
  }, [])

  const showFeature = false // Flag to hide features that are not included in the MVP
  return (
    <Formik
      initialValues={{ memberEmails: [] }}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    >
      {({ values, errors, handleChange, setFieldValue }) => (
        <Form>
          <Paper>
            <Box paddingBottom={2}>
              <DialogTitle>
                Invite people via email
                <ButtonDialogClose onClick={onClose} />
              </DialogTitle>
              <DialogContent>
                {showFeature && (
                  <Box display="flex" justifyContent="flex-end" marginBottom={2}>
                    <LinkButton color="primary">Preview Email</LinkButton>
                  </Box>
                )}
                <Box marginBottom={4}>
                  <InputMemberEmails
                    name="memberEmails"
                    fieldValue={values.memberEmails}
                    setFieldValue={setFieldValue}
                    error={errors.memberEmails}
                  />
                </Box>
                {showFeature && (
                  <TextField
                    name="memberRole"
                    fullWidth
                    select
                    variant="outlined"
                    value={values.memberRole}
                    onChange={handleChange}
                  >
                    <MenuItem value="member">Member</MenuItem>
                    <MenuItem value="admin">Administrator</MenuItem>
                  </TextField>
                )}
              </DialogContent>
              <DialogActions>
                <ButtonSubmit submitting={submitting} variant="contained" color="primary">
                  Send Invites
                </ButtonSubmit>
              </DialogActions>
            </Box>
            <Box className={classes.infoAlert}>
              <Lock className={classes.lockIcon} fontSize="small" />
              Uploaded emails will be used for sending invites only in accordance with our&nbsp;
              <Link href={privacyPolicyRoute.path} target="_blank">
                Privacy Policy.
              </Link>
            </Box>
          </Paper>
        </Form>
      )}
    </Formik>
  )
}

export default InviteByEmail
